export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  // 概览模块
  'menu.overview': '概览模块',
  'menu.overview.dashboard': '仪表盘',
  'menu.overview.prd': 'PRD 管理',
  'menu.overview.theme': '主题管理',
  // 租户管理
  'menu.tenant': '租户管理',
  'menu.tenant.list': '租户列表',
  'menu.tenant.package': '租户套餐',
  'menu.tenant.store': '门店管理',
  'menu.tenant.mall': '商城管理',
  'menu.tenant.uploadlog': '上传日志',
  'menu.tenant.deadline': '到期管理',
  // 代理商中心
  'menu.agent': '代理商中心',
  'menu.agent.profile': '代理商列表',
  // 设备管理
  'menu.device': '设备管理',
  'menu.device.register': '设备终端',
  'menu.device.log': '设备日志',
  // 系统设置
  'menu.setting': '系统设置',
  'menu.setting.user': '用户管理',
  'menu.setting.role': '角色管理',
  'menu.setting.menu': '菜单管理',
  'menu.setting.department': '部门管理',
  'menu.setting.dictionary': '字典管理',
  'menu.setting.parameter': '参数管理',
  // 运维管理
  'menu.ops': '运维管理',
  'menu.ops.cron': '定时任务',
  'menu.ops.version': '版本管理',
  'menu.ops.template': '消息模板',
  'menu.ops.message': '消息管理',
  // B账调整
  'menu.accountB': 'B账调整',
  'menu.accountB.accountBConfig': 'B账配置',
  'menu.accountB.dataReset': 'B账数据重置',
  // 日志管理
  'menu.log': '日志管理',
  'menu.log.operation': '操作日志',
  'menu.log.login': '登录日志',
  'menu.log.audit': '审计日志',
  'menu.log.rawIngestion': '上传报文',
  // 定时任务
  'menu.cron': '定时任务',
  'menu.cron.list': '任务列表',
  'menu.cron.record': '执行记录',
  // 商城配置
  'menu.mall': '商城配置',
  'menu.mall.config': '配置列表',
  // 隐藏页页签标题(add/edit/detail 不在菜单, 多页签栏按路径取 key)
  'menu.tenant.list.add': '新增租户',
  'menu.tenant.list.detail': '租户详情',
  'menu.tenant.list.edit': '编辑租户',
  'menu.tenant.store.add': '新增门店',
  'menu.tenant.store.edit': '编辑门店',
  'menu.ops.version.add': '新增版本',
  'menu.ops.version.edit': '编辑版本',
  'menu.accountB.accountBConfiguration': 'B账配置',
  'menu.accountB.accountBConfiguration.add': '新增B账配置',
  'menu.accountB.accountBConfiguration.detail': 'B账配置详情',
  'menu.accountB.accountBConfiguration.edit': '编辑B账配置',
  'menu.mall.config.add': '新增商城配置',
  'menu.mall.config.detail': '商城配置详情',
  'menu.mall.config.edit': '编辑商城配置',
  // 多页签栏操作
  'tabs.close.left': '关闭左侧',
  'tabs.close.right': '关闭右侧',
  'tabs.close.others': '关闭其他',
  'tabs.refresh': '刷新',
};
